import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Card from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Card';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import { Checkbox, FormControlLabel } from '@material-ui/core';
import Typography from 'Components/UI/Typography';

const styles = (theme) => ({
  root: {
  },
  card: {
    padding: theme.spacing(0.5),
    cursor: 'pointer',
    height: '50px',
  },
  readonlyCard: {
    padding: theme.spacing(0.5),
  },
  cardSelected: {
    color: 'white',
    backgroundColor: theme.palette.facet.accentBlue11,
  },
  icon: {
    color: theme.palette.facet.mediumGray,
  },
  iconSelected: {
    color: theme.palette.facet.accentGreen4,
  },
  checkbox: {
    margin: 0,
    height: '50px',
    whiteSpace: 'nowrap',
  },
});

const CardCheckbox = ({
  classes,
  className,
  label,
  value,
  onChange,
  selectedColor,
  hidden,
  CheckboxProps,
}) => {
  return (
    <div className={classNames(classes.root, className)}>
      <Card
        variant="outlined"
        onClick={onChange ? () => {
          onChange({ target: { checked: !value } });
        } : null}
        className={classNames({
          [classes.card]: !!onChange,
          [classes.readonlyCard]: !onChange,
          [classes.cardSelected]: value,
        })}
        style={(value && selectedColor) ? { backgroundColor: selectedColor } : {}}
      >
        <FormControlLabel
          className={classes.checkbox}
          control={
            <Checkbox
              checked={value}
              icon={<FiberManualRecordIcon className={classes.icon} />}
              checkedIcon={<FiberManualRecordIcon className={classNames(classes.icon, classes.iconSelected)} />}
              onChange={onChange}
              onClick={(event) => {
                event.stopPropagation();
              }}
              {...CheckboxProps}
            />
          }
          onClick={(event) => {
            event.stopPropagation();
          }}
          label={<Typography variant="h6">{label}</Typography>}
          hidden={hidden}
        />
      </Card>
    </div>
  );
};

CardCheckbox.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  label: PropTypes.string.isRequired,
  value: PropTypes.bool.isRequired,
  onChange: PropTypes.func,
  selectedColor: PropTypes.string,
  hidden: PropTypes.bool,
  CheckboxProps: PropTypes.object,
};

CardCheckbox.defaultProps = {
  className: '',
  selectedColor: '',
  hidden: false,
  CheckboxProps: {},
  onChange: null,
};

export default withStyles(styles)(CardCheckbox);
